import { render } from "./AllBankView.vue?vue&type=template&id=4702c374"
import script from "./AllBankView.vue?vue&type=script&lang=js"
export * from "./AllBankView.vue?vue&type=script&lang=js"

import "./AllBankView.vue?vue&type=style&index=0&id=4702c374&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__